import React from 'react';
import { DotsStyles as S } from './Dots.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
const Dots = ({ activeIndex, itemCount, variant }) => {
    return (React.createElement(S.Dots, { "data-variant": variant ?? ContentType.Default },
        React.createElement(S.Dot, { style: { '--progress': `${((activeIndex + 1) / itemCount) * 100}%` } })));
};
export default Dots;
